import { QueryResult, useQuery } from 'react-query';
import { useFetchConfig } from './dart';
import useAppData from '../services/ups';

export const useSMSService = (options?): QueryResult<any> => {
  const moduleName = 'SMS_DETAILS';
  const smsKey = 'SMSInfo';
  const isFirstBoxShippedKey = 'hasFirstShipmentCompleted';
  const fetchSMSConfig = useFetchConfig({
    moduleList: [moduleName],
    sourceEventId: options?.sourceEventId,
    clusterValue: options?.clusterValue

  });
  const useAppDataFetch = useAppData({});
  const checkIfSMSServiceEnabled = (configuration): boolean => {
    const isSMSEnabled = !(
      (configuration[moduleName]?.state === 'enabled' &&
        configuration[moduleName]?.['sms.enabled']?.toLowerCase() === 'false')
    );

    return isSMSEnabled;
  };
  const getAppSMSInfo = (appSMSInfo) => {
    if (appSMSInfo && appSMSInfo.value) {
      try {
        return {
          ...JSON.parse(appSMSInfo.value)
        };
      } catch (error) {
        console.log(error);
      }
    }

    return {};
  };
  const checkIsFirstBoxShipped = (isFirstBoxShipped): boolean => {
    if (isFirstBoxShipped && isFirstBoxShipped.value) {
      try {
        return !!JSON.parse(isFirstBoxShipped.value);
      } catch (error) {
        console.log(error);

        return false;
      }
    }

    return false;
  };

  async function fetchSMSInfo(): Promise<any> {
    const smsInfoDefaults = {
      isSMSServiceEnabled: false,
      optInPopupSeen: false,
      isFirstBoxShipped: false
    };

    try {
      const [appData, configuration] = await Promise.all([
        useAppDataFetch.refetch(),
        fetchSMSConfig.refetch()
      ]);
      const appSMSInfo = appData.find((item) => item.key === smsKey);
      const isFirstBoxShipped = appData.find((item) => item.key === isFirstBoxShippedKey);
      const smsInfo = {
        ...smsInfoDefaults,
        ...getAppSMSInfo(appSMSInfo),
        isSMSServiceEnabled: checkIfSMSServiceEnabled(configuration),
        isFirstBoxShipped: checkIsFirstBoxShipped(isFirstBoxShipped)
      };

      return smsInfo;
    } catch (error) {
      console.error('Error fetching SMS:', error);
      throw error;
    }
  }

  return useQuery('fetchSMS', fetchSMSInfo, {
    retry: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    onSuccess: options?.onSuccess,
    enabled: options?.enabled
  });
};
